import { z } from 'zod';
export const roundStatusValues = ['open', 'closed'];
export const RoundStatusSchema = z.enum(roundStatusValues);
//# sourceMappingURL=session-round.js.map